import { ModoPagamentoContaModel } from './../../models/financeiro/modo-pagamento-conta.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';

import { CartModel } from '@models/outros/cart.model';
import { CartItemModel } from '@models/outros/cart.model';
import { LocalStorageService } from 'ngx-webstorage';
import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';
import { ProdutoModel } from '@models/financeiro/produto.model';
import { Variables } from '@utils/variables';
@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {

  private _sales$ = new BehaviorSubject<boolean>(false);
  private _addProductSubject$ = new BehaviorSubject<CartItemModel>(new CartItemModel());
  private _cartSubject$ = new BehaviorSubject<CartModel>(new CartModel());
  private _products: ProdutoModel[] = new Array<ProdutoModel>();
  private _total$ = new BehaviorSubject<{total: number; totalMarketPlace: number}>(null);

  constructor(
    private _storage: LocalStorageService
  ) {
    this._recoverFromStorage();
  }

  addProduct(product: ProdutoModel, candidate: MatriculaGestaoModel) {

    let cart: CartModel =  Object.assign({}, this.getCart());
    let atualCandidato = this.getCandidate();

    if (!atualCandidato || candidate.id != atualCandidato.id) {
      cart = Object.assign({}, new CartModel());
      cart.candidato = candidate;
    }

    let itemInCart = cart.venda.find(x => x.produto.id === product.id);

    if (itemInCart) {
      itemInCart.quantidade++;
      this.setCart(cart);
      return({item: itemInCart, newItem: false})
    } else {
      let venda: CartItemModel = new CartItemModel();
      venda.idProduto = product.id;
      venda.produto = product;
      venda.quantidade = 1;
      cart.venda.push(venda)
      this.setCart(cart);
      this._setNewItemToCart(venda)
      return({item: venda, newItem: true})
    }
  }

  checkQuantityIsZero(product: ProdutoModel): boolean {
    let itemInCart = Object.assign({}, this.getCart().venda.find(x => x.produto.id === product.id));
    itemInCart.quantidade--;
    return itemInCart.quantidade <= 0
  }

  clearCart(): void {
    let cart = new CartModel();
    this.setCart(cart);
  }

  getCandidate(): MatriculaGestaoModel {
    return this._cartSubject$.getValue().candidato;
  }

  getCart(): CartModel {
    return this._cartSubject$.getValue();
  }

  getCartSubject(): Observable<CartModel> {
    return this._cartSubject$.asObservable();
  }

  getNewItem(): Observable<CartItemModel> {
    return this._addProductSubject$.asObservable();
  }

  getProducts(): ProdutoModel[] {
    return this._products;
  }

  getSales(): Observable<boolean> {
    return this._sales$.asObservable();
  }

  getTotal(): Observable<{total: number; totalMarketPlace: number}> {
    return this._total$.asObservable();
  }

  removeProduct(product: ProdutoModel) {
    let cart = this.getCart();
    let itemInCart = cart.venda.find(x => x.produto.id === product.id);
    itemInCart.quantidade--;
    if (itemInCart.quantidade <= 0) {
      let index = cart.venda.findIndex(x => x.produto.id == product.id);
      cart.venda = cart.venda.splice(index, 1);
      return({item: itemInCart, remove: true})
    }
    this.setCart(cart);
    return({item: itemInCart, remove: false})
  }

  setProducts(products: ProdutoModel[]) {
    this._products = products;
    this._storage.store(Variables.PRODUCTS, products);
  }

  setSales(value: boolean) {
    this._sales$.next(value);
  }

  setTotal(total: {total: number; totalMarketPlace: number}): void {
    this._total$.next(total);
  }

  setCart(cart: CartModel): void {
    this._cartSubject$.next(cart)
    this._storage.store(Variables.SHOPPING_CART, cart);
  }

  private _setNewItemToCart(item): void {
    this._addProductSubject$.next(item);
  }

  private _recoverFromStorage(): void {
    if (this._storage.retrieve(Variables.SHOPPING_CART)) {
      let cart: CartModel = this._storage.retrieve(Variables.SHOPPING_CART);
      this._products = this._storage.retrieve(Variables.PRODUCTS);
      this._cartSubject$.next(cart);
    }
  }
}
